var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5628 9.50329C12.0921 9.783 11.5516 9.93151 11 9.93151C10.4484 9.93151 9.90786 9.783 9.43643 9.50172L0 3.90979V14.0644C0 15.3608 1.05286 16.4215 2.35714 16.4215H19.6429C20.9471 16.4215 22 15.3608 22 14.0644V3.90979L12.5628 9.50329Z",
    fill: "#A9A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1584 8.28614C10.413 8.43779 10.7029 8.51714 10.9999 8.51714C11.2969 8.51714 11.5876 8.437 11.8406 8.28693L21.9913 2.27071C21.9449 1.01514 20.9172 0 19.6428 0H2.35705C1.08262 0 0.0549021 1.01514 0.00854492 2.27071L10.1584 8.28614Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.31a82a1c72aa9892953dfb2c3b9d3bd1.svg";
export { ForwardRef as ReactComponent };